"use client";

import { Button } from "../ui/button";
import { Laptop, Armchair, Smartphone, Lightbulb, Sparkles, HelpCircle } from "lucide-react";

interface SuggestionChipsProps {
  onSelect: (prompt: string) => void;
  suggestions?: { label: string; prompt: string }[];
}

const defaultSuggestions = [
  { label: "Find a Laptop", prompt: "Can you recommend a good laptop for software development?", icon: Laptop },
  { label: "Patio Furniture", prompt: "What are the best patio furniture options for a small backyard?", icon: Armchair },
  { label: "Compare Phones", prompt: "Compare the best smartphones available right now", icon: Smartphone },
  { label: "Make a Plan", prompt: "Help me plan a weekend trip to the mountains", icon: Lightbulb },
  { label: "Help Me Write", prompt: "Help me write a professional email to follow up after an interview", icon: Sparkles },
  { label: "Explain a Concept", prompt: "Explain how neural networks learn in simple terms", icon: HelpCircle },
];

export function SuggestionChips({ onSelect, suggestions }: SuggestionChipsProps) {
  const chips = suggestions || defaultSuggestions;

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      {chips.map((suggestion) => {
        const Icon = "icon" in suggestion ? (suggestion as { icon: typeof Laptop }).icon : Sparkles;
        return (
          <Button
            key={suggestion.label}
            variant="outline"
            size="sm"
            className="h-9 rounded-full px-4 text-sm font-normal gap-1.5 border-input"
            onClick={() => onSelect(suggestion.prompt)}
          >
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
            {suggestion.label}
          </Button>
        );
      })}
    </div>
  );
}
